import React, { Suspense, lazy } from "react";
import HeroSection from "../components/Home/HeroSection";
import ProjectsSectionSkeleton from "../components/Skeleton/ProjectsSectionSkeleton";
import useAfterFirstPaint from "../hooks/useAfterFirstPaint";

const ProjectsSection = lazy(() => import("../components/Home/ProjectsSection"));

const Home = () => {
  const showProjects = useAfterFirstPaint();

  return (
    <>
      <HeroSection />
      {showProjects ? (
        <Suspense fallback={<ProjectsSectionSkeleton />}>
          <ProjectsSection />
        </Suspense>
      ) : (
        <ProjectsSectionSkeleton />
      )}
    </>
  );
};

export default Home;
